import dayjs, {Dayjs} from "dayjs"

export default class MinimalManager {
    public firstName: string
    public lastName: string
    public communityName?: string
    public communityReference?: string
    public email?: string
    public telephone?: string
    public createdAt: Dayjs

    constructor(data: any) {
        this.firstName = data.firstName
        this.lastName = data.lastName
        this.email = data.email
        this.telephone = data.telephone
        this.communityName = data.communityName
        this.communityReference = data.communityReference
        this.createdAt = dayjs(data.createdAt)
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`
    }

    static getClone = (data: any) => {
        return new MinimalManager({
            ...data,
            reference: data.id,
        })
    }

}
